import React, { useContext } from "react";
import { ApplyContext } from "~/pages/applyFormMange/ApplyRegContext";
import { useTranslation } from "react-i18next";
const InquiryLink = ({ card }) => {
	const { t } = useTranslation();
	const { setListByTarget } = useContext(ApplyContext);
	const handleChange = (e) => {
		setListByTarget({ ...card, title: e.target.value });
	};

	return (
		<div className="c__form horiz">
			<div className="f__group export-label ">
				<div className="f__control  ">
					<input
						name="inquiryLink"
						className="c__input f__item"
						placeholder={t(
							"pages.round.RoundReg.Inquiry.content.cardType.InquiryLink.question"
						)}
						type="text"
						value={card.title}
						onChange={handleChange}
					/>
				</div>
			</div>
			<div className="export-input-preview">
				{t("pages.round.RoundReg.Inquiry.content.cardType.InquiryLink.url")}
			</div>
			<p className="request-phrase">
				{t("pages.round.RoundReg.Inquiry.content.cardType.InquiryLink.checkSetting")}
			</p>
		</div>
	);
};

export default InquiryLink;
